import { useHasBusinessEntityPermit } from '../businessEntity/queries';
import { useHasPermission } from '../permissions/PermissionsProvider';

/**
 * Check if the user has a permit for using the chatbot globally.
 */
export const useHasChatbotPermit = () =>
  useHasPermission((permits) =>
    permits.some((permit) =>
      ['ai.chatbot:r', 'ai.chatbot:r.all'].includes(permit)
    )
  );

/**
 * Check if the user has a permit for using the chatbot on a specific equipment.
 *
 * For users (normally internal Sandvik users) that have the global permit
 * 'ai.chatbot:r.all', we don't have to check permits on individual entities, as
 * this permit implies access on all equipment.
 *
 * End customer users however may have the permit 'ai.chatbot:r' on only some
 * equipment, so there we have to check on each entity.
 */
export const useHasChatbotEquipmentPermit = (equipment?: Equipment) => {
  const hasChatbotAllPermit = useHasPermission('ai.chatbot:r.all');
  const entityId = hasChatbotAllPermit ? undefined : equipment?.entityId;
  const entityPermit = useHasBusinessEntityPermit(entityId, 'ai.chatbot:r');
  const hasPermit = hasChatbotAllPermit || entityPermit.hasPermit;

  return { hasPermit, permitIsLoading: entityPermit.isLoading };
};
